export const FORCE_RELOAD_IFRAME = "FORCE_RELOAD_IFRAME";

export const forceReloadIframe = () => ({
  type: FORCE_RELOAD_IFRAME,
  payload: Date.now(), // or a simple counter
});
